import React, { FC } from "react";
import { Structure } from "@shared/Map/objects/structures/Structure";
import InhibitorIcon from "@assets/img/structures/inhib.svg?react";
import { BuildingObject } from "@shared/Map/types";

export const Inhibitor: FC<{ inhib: BuildingObject }> = ({ inhib }) => {
	return (
		<Structure position={inhib.position} teamId={inhib.teamId} show={inhib.life > 0} size={800}>
			<InhibitorIcon width={800} height={800} />
		</Structure>
	);
};
